module.exports = __webpack_public_path__ + "static/media/dontbutton.c0e68f66.png";